import {
  COLLECTIONS_CREATE_COLLECTION_WITH_JSON_BEGIN,
  COLLECTIONS_CREATE_COLLECTION_WITH_JSON_SUCCESS,
  COLLECTIONS_CREATE_COLLECTION_WITH_JSON_FAILURE,
  COLLECTIONS_CREATE_COLLECTION_WITH_JSON_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';

export function createCollectionWithJson(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_CREATE_COLLECTION_WITH_JSON_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/create-with-json`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_CREATE_COLLECTION_WITH_JSON_SUCCESS,
            data: res.data,
          });
          Mixpanel.track('Created Collection', {
            uuid: res.data.uuid,
            colletionName: res.data.colletionName,
          });
          toast.success('Collection Created Successfully !');
          resolve(res);
        },
        (err) => {
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          Mixpanel.track('Failed to creat collection');
          dispatch({
            type: COLLECTIONS_CREATE_COLLECTION_WITH_JSON_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateCollectionWithJsonError() {
  return {
    type: COLLECTIONS_CREATE_COLLECTION_WITH_JSON_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_CREATE_COLLECTION_WITH_JSON_BEGIN:
      return {
        ...state,
        createCollectionWithJsonPending: true,
        createCollectionWithJsonError: null,
      };

    case COLLECTIONS_CREATE_COLLECTION_WITH_JSON_SUCCESS:
      return {
        ...state,
        createCollectionWithJsonPending: false,
        createCollectionWithJsonError: null,
        projectCollections: [...state.projectCollections, action.data],
        selectedCollection: action.data,
        items: [],
      };

    case COLLECTIONS_CREATE_COLLECTION_WITH_JSON_FAILURE:
      return {
        ...state,
        createCollectionWithJsonPending: false,
        createCollectionWithJsonError: action.data.error,
      };

    case COLLECTIONS_CREATE_COLLECTION_WITH_JSON_DISMISS_ERROR:
      return {
        ...state,
        createCollectionWithJsonError: null,
      };

    default:
      return state;
  }
}
